import axios from '../../axios'

/*
 * 院校数据接口
 */
// 获取院校列表
export const getSchoolList = (data) => {
    return axios({
        url: '/api/data/wish/school',
        method: 'get',
        data
    })
}

// 获取院校列表
export const getSimpleSchExamSchoolList = (data) => {
    return axios({
        url: '/api/data/wish/sch/exam/school',
        method: 'get',
        data
    })
}

// 新增院校信息
export const saveSchool = (data) => {
    return axios({
        url: '/api/data/wish/school',
        method: 'post',
        data
    })
}

// 编辑院校信息
export const updateSchool = (data) => {
    return axios({
        url: '/api/data/wish/school',
        method: 'put',
        data
    })
}

// 删除院校列表
export const deleteSchool = (data) => {
    return axios({
        url: '/api/data/wish/school',
        method: 'delete',
        data
    })
}


// 获取院校详情
export const getSchoolInfo = (data) => {
    return axios({
        url: '/api/data/wish/school/info',
        method: 'get',
        data
    })
}

// 获取全部标签
export const typeListAll = (data) => {
    return axios({
        url: '/api/data/wish/type/list_all',
        method: 'get',
        data
    })
}

// 校考日历
// 删除校考院校列表
export const deleteSchExamSchool = (data) => {
    return axios({
        url: '/api/data/wish/sch/exam/school',
        method: 'delete',
        data
    })
}
// 获取校考院校详情
export const getSchExamSchoolInfo = (data) => {
    return axios({
        url: '/api/data/wish/sch/exam/school/info',
        method: 'get',
        data
    })
}
// 编辑校考日历院校信息
export const updateSchExamSchool = (data) => {
    return axios({
        url: '/api/data/wish/sch/exam/school',
        method: 'put',
        data
    })
}

// 查询校区
export const getSchoolCampusList = (data) => {
    return axios({
        url: '/api/data/wish/campus',
        method: 'get',
        data
    })
}

// 新增校区
export const saveSchoolCampus = (data) => {
    return axios({
        url: '/api/data/wish/campus',
        method: 'post',
        data
    })
}

// 更新校区
export const updateSchoolCampus = (data) => {
    return axios({
        url: '/api/data/wish/campus',
        method: 'put',
        data
    })
}

// 删除校区
export const deleteSchoolCampus = (data) => {
    return axios({
        url: '/api/data/wish/campus',
        method: 'delete',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/wish/school.js